/**
 * Names this product PRINTS, cleaned of the marks it does not print.
 *
 * The browser twin of `backend/src/domain/display-text.ts`. The backend already strips the mark
 * from the public projection, so in the product this is usually a no-op — it is here because the
 * name also reaches these surfaces from places the backend projection does not pass through: the
 * demo's own seed, a record's release snapshot, and the settings a deployment configured.
 *
 * What is never passed through it: public codes, identifiers, URLs, claim tokens and verification
 * codes. Those are matched and resolved elsewhere, and rewriting a character inside one would break
 * the thing it identifies.
 */
export const withoutRegisteredMark = (text: string): string =>
  text
    .replace(/[®™]/g, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
